function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgDatev = function SvgDatev(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 88.596 87.364",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M.063 67.125v20.25h7.312c5.446 0 10.125-4.368 10.125-9.969-.155-6.224-4.054-10.281-9.5-10.281zm24.437 0-7.781 20.25h4.343l6.063-16.031 5 12.75H26.5v3.281h11.219l-7.938-20.25zm9.781 0v3.438h6.563v16.812h4.5V70.563h6.375v-3.438zm19.157 0v20.25h14v-3.281H57.78V78.5h8.563v-3.437H57.78v-4.5h9.188v-3.438zm14.624 0L76 87.375h4.813l7.78-20.25H77.876v3.438H83l-4.687 12.28-5.75-15.718zM4.25 70.563h3.438c3.422 0 5.75 2.486 5.593 6.687-.155 4.358-3.11 6.687-6.687 6.688H4.25z",
    style: {
      fill: "#00a992",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-20.298 42.767H67.98v-62.449H-20.3z",
    style: {
      fill: "#96d550",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(20.298 19.682)"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDatev);
export default ForwardRef;